import { formatUrlSuffix, isObject, isString } from '@libs/shared';
import { globalState } from '../../models';

/**
 * 通过Proxy为API提供baseURL前缀
 * @param api
 */
export const createAPIProxy = <T extends object>(api: T): T => {
    return new Proxy(api, {
        get(target, propKey: string) {
            const value = Reflect.get(target, propKey);
            if (api.propertyIsEnumerable(propKey)) {
                if (isString(value)) {
                    return formatUrlSuffix(globalState.origin, value);
                }
                if (isObject(value)) {
                    return createAPIProxy(value);
                }
            }
            return value;
        }
    });
};
